/**
 * Language selector component
 * PURPOSE: Switches between French, English and Arabic and supports compact display.
 *
 * EDITING GUIDE:
 * - Read the comments above each section or function before changing behavior.
 * - Keep validation, authentication and error handling in place for production safety.
 * - Search for "EDIT HERE" to find the most common business-content settings.
 */

import React from 'react';
import { useLanguage } from '../i18n';
import './LanguageSwitcher.css';

export default function LanguageSwitcher({ compact = false }) {
  const { language, setLanguage } = useLanguage();
  return (
    <div className={`language-switcher ${compact ? 'compact' : ''}`} aria-label="Change language">
      {/* EDIT HERE: change labels or add another supported language. */}
      {[
        ['fr', 'FR'],
        ['en', 'EN'],
        ['ar', 'AR'],
      ].map(([code, label]) => (
        <button
          type="button"
          key={code}
          className={language === code ? 'active' : ''}
          onClick={() => setLanguage(code)}
          aria-pressed={language === code}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
